import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
    static targets = ["modal", "marksContainer"]

    connect() {
        this.modalInstance = new Modal(this.modalTarget)
    }

    openModal(event) {
        const marks = JSON.parse(event.currentTarget.dataset.marks)
        this.renderMarks(marks)
        this.modalInstance.show()
    }

    renderMarks(marks) {
        const packMarks = marks.filter(m => m.pack_mark)
        const itemMarks = marks.filter(m => m.item_mark)

        let html = ""

        const totalItemMarks = packMarks.reduce((sum, m) => sum + (m.item_marks || []).length, 0) + itemMarks.length

        if (packMarks.length > 0) {
            html += `<div class="accordion mb-3" id="marksAccordion">`
            packMarks.forEach((mark, index) => {
                const collapseId = `marks-collapse-${index}`
                const headingId = `marks-heading-${index}`
                const itemMarksCount = (mark.item_marks || []).length
                html += `
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="${headingId}">
                            <button class="accordion-button collapsed" type="button"
                                    data-bs-toggle="collapse" data-bs-target="#${collapseId}"
                                    aria-expanded="false" aria-controls="${collapseId}">
                                <i class="bi bi-box me-2 text-secondary"></i>
                                <code>${this.escapeHtml(mark.pack_mark)}</code>
                                <span class="badge bg-secondary ms-2">${itemMarksCount}</span>
                            </button>
                        </h2>
                        <div id="${collapseId}" class="accordion-collapse collapse"
                             aria-labelledby="${headingId}" data-bs-parent="#marksAccordion">
                            <div class="accordion-body p-0">
                                <table class="table table-sm table-hover mb-0">
                                    <tbody>
                                        ${(mark.item_marks || []).map((im, i) => `
                                            <tr>
                                                <td class="text-muted ps-3 pe-2" style="width:1%">${i + 1}</td>
                                                <td><code>${this.escapeHtml(im)}</code></td>
                                            </tr>
                                        `).join("")}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                `
            })
            html += `</div>`
        }

        if (itemMarks.length > 0) {
            html += `
                <table class="table table-sm table-striped">
                    <thead class="table-light">
                        <tr>
                            <th style="width:1%">#</th>
                            <th>Марка единицы</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${itemMarks.map((mark, i) => `
                            <tr>
                                <td class="text-muted">${i + 1}</td>
                                <td><code>${this.escapeHtml(mark.item_mark)}</code></td>
                            </tr>
                        `).join("")}
                    </tbody>
                </table>
            `
        }

        html += `
            <div class="d-flex justify-content-end align-items-center border-top pt-2 mt-2">
                <span class="text-muted me-2">Общее количество марок:</span>
                <span class="badge bg-primary fs-6">${totalItemMarks}</span>
            </div>
        `

        this.marksContainerTarget.innerHTML = html
    }

    closeModal() {
        this.modalInstance.hide()
        this.marksContainerTarget.innerHTML = ""
    }

    escapeHtml(str) {
        return String(str)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
    }
}
